var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._g({staticClass:"svg-icon",style:({ 'font-size': _vm.size + 'px', 'color': _vm.color }),attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":'#' + _setup.iconId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }